// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { ProviderResponse } from './provider-response';

// @ts-ignore
import { RapidReviewContactLensEyeResponse } from './rapid-review-contact-lens-eye-response';

/** See com.rev360.pms.api.controller.encounter.rapidreview.RapidReviewContactLensPrescriptionResponse */
/* istanbul ignore next */
@GandalfModel
export class RapidReviewContactLensPrescriptionResponse extends GandalfModelBase {

	@GandalfConstantDecorator(constants.PrescriptionAuthorizationType)
	@GandalfProperty({ designType: constants.PrescriptionAuthorizationType })
	authorizationType!: constants.PrescriptionAuthorizationType;

	@GandalfProperty({ designType: ProviderResponse })
	authorizedBy!: ProviderResponse | null;

	@GandalfProperty({ designType: Number })
	contactLensPrescriptionId!: number;

	@GandalfProperty({ designType: Date })
	expirationDate!: Date | null;

	@GandalfProperty({ designType: RapidReviewContactLensEyeResponse })
	od!: RapidReviewContactLensEyeResponse | null;

	@GandalfProperty({ designType: RapidReviewContactLensEyeResponse })
	os!: RapidReviewContactLensEyeResponse | null;

	@GandalfConstantDecorator(constants.PrescriptionCurrentStatus)
	@GandalfProperty({ designType: constants.PrescriptionCurrentStatus })
	status!: constants.PrescriptionCurrentStatus;

}
